import { render, staticRenderFns } from "./GlobalPlayer.vue?vue&type=template&id=42680c86&scoped=true"
import script from "./GlobalPlayer.vue?vue&type=script&lang=js"
export * from "./GlobalPlayer.vue?vue&type=script&lang=js"
import style0 from "./GlobalPlayer.vue?vue&type=style&index=0&id=42680c86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42680c86",
  null
  
)

export default component.exports